import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CalendarParamsState, SelectedColumn } from './types';

interface State {
  calendar_state: CalendarParamsState;
  configColumn: SelectedColumn[];
}
const initialState: State = {
  calendar_state: {},
  configColumn: []
};

const slice = createSlice({
  name: 'fast-moving-products',
  initialState,
  reducers: {
    calendarParamsActions(state, action: PayloadAction<CalendarParamsState>) {
      state.calendar_state = { ...state.calendar_state, ...action?.payload };
    },
    // save the selected columns for fast moving products
    saveConfigColumn(state, action: PayloadAction<SelectedColumn[]>) {
      state.configColumn = action?.payload;
    }
  }
});

export const reducer = slice.reducer;
export const actions = { ...slice?.actions };
